const Template = ` <div>
   <form class="login" @submit.prevent="login" autocomplete="on">
   <br>
     <b-dropdown id="auth-lang" dropleft class="" size="sm" variant="link" no-caret>
      <template v-slot:button-content>
        <vf-icon :country="$t('general.langType')"/> {{$t('general.lang')}}
      </template>
      <b-dropdown-item href="#" @click="setLocale('ru')"><vf-icon country="ru"/> {{this.$i18n.messages.ru.general.lang}}</b-dropdown-item>
      <b-dropdown-item href="#" @click="setLocale('gb')"><vf-icon country="gb"/> {{this.$i18n.messages.gb.general.lang}}</b-dropdown-item>
    </b-dropdown>
     <h1>{{$t('auth.signIn')}}</h1>
     <label>{{$t('auth.login')}}</label><br>
     <input required v-model="username" name="username" type="text" :placeholder="$t('auth.login')" autocomplete="username"/><br><br>
     <label>{{$t('auth.password')}}</label></br>
     <input required v-model="password" name="password" type="password" :placeholder="$t('auth.password')" autocomplete="password"/><br>
     <br>
     <button type="submit" :disabled="!username || !password">{{$t('auth.signIn')}}</button>
   </form>
 </div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/auth/template.js